import bamboo from '../../images/clients/bamboo_rock.jpg'
import mbeya from '../../images/clients/mbeya.jpg'
import shanta from '../../images/clients/shanta.jpg'
import stamico from '../../images/clients/stamico.jpg'
import trl from '../../images/clients/trl.jpg'
import yapi_merkezi from '../../images/clients/yapi_makenzi.jpg'

export const clients = [
    {
        'name': 'Shanta Gold',
        'image': shanta,
    },
    {
        'name': 'Bamboo Rock Construction',
        'image': bamboo,
    },
    {
        'name': 'Mbeya Cement',
        'image': mbeya,
    },
    {
        'name': 'Stamico',
        'image': stamico,
    },
    {
        'name': 'Tanzania Railways Limited',
        'image': trl,
    },
    {
        'name': 'Yapi Merkezi',
        'image': yapi_merkezi,
    },
]